export default {
  namespaced: true,
  state: {
    selected_menu: 0,
    list: [

      {
        title: "General",
        icon: "$generalIcon",
        children: [
          {
            title: "Dashboard",
            link: "/admin/dashboard"
          },
          {
            title: "Map",
            link: "/admin/map",
          },
        ],
      },
      {
        title: "Gestion de usuarios",
        icon: "$gestionUserIcon",
        children: [
          {
            title: "Usuarios",
            link: "/admin/users_scroll",
          },
          {
            title: "Sub admin",
            link: "/admin/user_enterprises",
          },
          {
            title: "Usuarios eliminados",
            link: "/admin/deleted_users",
          },
          {
            title: "Historial de carga de coins",
            link: "/admin/coins_refunds",
          },
          {
            title: "Usuarios Reportados",
            link: "/admin/user_reports",
          },
        ],
      },
      {
        title: "Spots y vehículos",
        icon: "$spotsIcon",
        children: [
          {
            title: "Nuevos spots",
            link: "/admin/notifications_cms",
          },
          {
            title: "Spots eliminados",
            link: "/admin/deleted_spots",
          },
          {
            title: "Autos y patentes",
            link: "/admin/cars",
          },
          {
            title: "Marcas de autos",
            link: "/admin/car_brands",
          },
          {
            title: "Tipos de spots",
            link: "/admin/type_spots",
          },
          {
            title: "Tamaños de spots",
            link: "/admin/size_spots",
          },
          {
            title: "Comodidades",
            link: "/admin/amenities",
          },
          {
            title: "Provincias",
            link: "/admin/provinces",
          },
          {
            title: "Etiquetas",
            link: "/admin/tags",
          },
        ],
      },

      {
        title: "Reservas y estadías",
        icon: "$rentIcon",
        children: [
          {
            title: "Estadias",
            link: "/admin/rent_trakers",
          },
          {
            title: "Instrucciones estadia",
            link: "/admin/stay_instructions",
          },
          {
            title: "Formulario ingresantes",
            link: "/admin/options",
          },
          {
            title: "Estadias por spot",
            link: "/admin/trakers",
          },
        ],
      },

      {
        title: "Finanzas",
        icon: "$financesIcon",
        children: [
          {
            title: "Compra de coins",
            link: "/admin/coin_purchases",
          },
          {
            title: "Coins",
            link: "/admin/coins",
          },
          {
            title: "Liquidaciones",
            link: "/admin/liquidations",
          },
          {
            title: "Comisión",
            link: "/admin/commissions/edit/general",
          },
          {
            title: "Precio sugerido",
            link: "/admin/suggested_prices",
          },
          {
            title: "Spot Precio",
            link: "/admin/prices/edit/general",
          },
        ],
      },

      {
        title: "Marketing y comunicación",
        icon: "$marketingIcon",
        children: [
          {
            title: "Cupones",
            link: "/admin/coupons",
          },
          {
            title: "Notificaciones CMS",
            link: "/admin/notifications_request_cms",
          },
          {
            title: "Notificaciones",
            link: "/admin/push_notifications",
          },
          {
            title: "Banners",
            link: "/admin/banners",
          },
          {
            title: "Anuncios App",
            link: "/admin/app_ads",
          },
        ],
      },

      {
        title: "Información y soporte",
        icon: "$infoIcon",
        children: [
          {
            title: "Reporte de ayuda",
            link: "/admin/spot_helps",
          },
          {
            title: "Opciones de ayuda",
            link: "/admin/help_options",
          },

          {
            title: "Ayuda",
            link: "/admin/helps",
          },

          {
            title: "FAQ's",
            link: "/admin/faqs",
          },
          {
            title: "Información adicional",
            link: "/admin/additional_info",
          },
        ],
      },
      {
        title: "Configuración y políticas",
        icon: "$configIcon",
        children: [
          {
            title: "Modo de verificación",
            link: "/admin/verifications/edit/general",
          },
          {
            title: "Política de privacidad",
            link: "/admin/privacy",
          },
          {
            title: "Terminos y condiciones",
            link: "/admin/terms",
          },
        ],
      },
    ],
    sub_list:[
    ],
    icon_detail: require("../../assets/img/icons/CalendarCheck.png"),
    icon_time: require("../../assets/img/icons/CalendarCheck.png"),
  },
  mutations: {
    set_selected_menu(state, selected) {
      state.selected_menu = selected;
    },
  },
  actions: {
    selected_menu({ commit }, selected) {
      commit("set_selected_menu", selected);
    },
  },
  getters: {},
  setters: {},
  modules: {},
};
